<div class="detail">
  <div>
    <a uiSref="^" class="button mb-10"><i class="fa fa-chevron-left mr-5"></i>Seznam geometrických plánů</a>
  </div>

  <h1>Vložit vyhotovený GP</h1>

  <div class="row mt-30">
    <div class="col-12 offset-lg-3 col-lg-6">
      <fieldset>
        <legend>Základní údaje</legend>
        <!-- cislo GP -->
        <gmt-input label="Číslo GP" [required]="true" class="mt-20">
          <input type="text" [(ngModel)]="geometricPlanRequest.name"/>
        </gmt-input>

        <!-- ucel GP -->
        <gmt-input label="Účel" [required]="true" class="mt-20">
          <gmt-select
            [optionItems]="typeOptions"
            [data]="this"
            field="type"
            required="true"
          ></gmt-select>
        </gmt-input>

        <gmt-input label="Zhotovitel" class="mt-10" [required]="true">
          <gmt-select
            resource="suppliers"
            [data]="geometricPlanRequest"
            field="supplier"
            [itemPipe]="projectSubjectNamePipe"
          ></gmt-select>
          <a (click)="onUpdateSupplier()" title="Upravit zhotovitele" *ngIf="geometricPlanRequest.supplier" class="button ml-5 not-underline">
            <span class="fa fa-pencil"></span>
          </a>
          <a (click)="onCreateSupplier()" title="Nový zhotovitel" class="button ml-5">
            <span class="fa fa-plus"></span>
          </a>
        </gmt-input>

        <!-- datum schvaleni konceptu -->
        <gmt-input label="Datum ověření GP" class="mt-10" [required]="true">
          <input type="text" pick-a-date [(ngModel)]="geometricPlanRequest.verificationDate"/>
        </gmt-input>

        <!-- datum schvaleni -->
        <gmt-input label="Datum potvrzení KP" class="mt-10" [required]="true">
          <input type="text" pick-a-date [(ngModel)]="geometricPlanRequest.approvedDate"/>
        </gmt-input>

        <!-- cislo PGP -->
        <gmt-input label="Číslo potvrzení GP (PGP)" class="mt-10" [required]="true">
          <input type="text" [(ngModel)]="geometricPlanRequest.pgpNumber" />
        </gmt-input>

        <br>
        <br>

        <!-- katastralni uzemi -->
        <gmt-input label="Katastrální území" [required]="true">
          <gmt-select
            resource="areas"
            [filter]="{ sortOrder: { sortBy: 'name' }}"
            [data]="this"
            field="area"
            required="false"
            (changed)="onCadastreChanged()"
          ></gmt-select>
        </gmt-input>

        <!-- LV -->
        <gmt-input label="LV" class="mt-20">
          <gmt-select
            resource="titles"
            [globalFilterConfig]="titleFilter"
            [data]="this"
            field="titles"
            required="false"
            [multiselect]="true"
            [itemPipe]="titleNamePipe"
            (changed)="onTitleChanged()"
          ></gmt-select>
        </gmt-input>

        <!-- stavebni objekty -->
        <gmt-input label="{{ 'CONSTRUCTION_OBJECT' | wordtranslate:true }}" class="mt-20" [required]="type?.id === typeEnum.EASEMENT_EXTENT">
          <gmt-select
            resource="construction-objects"
            [globalFilterConfig]="constructionObjectFilter"
            [filter]="{ sortOrder: { sortBy: 'socis' }}"
            [data]="geometricPlanRequest"
            field="constructionObjects"
            [multiselect]="true"
            required="false"
            [itemPipe]="constructionObjectNamePipe"
          ></gmt-select>
        </gmt-input>

        <!-- parcely -->
        <gmt-input label="Parcela" [required]="true" class="mt-20">
          <gmt-select
            resource="parcels"
            [globalFilterConfig]="parcelFilter"
            [data]="geometricPlanRequest"
            field="parcels"
            [multiselect]="true"
            required="false"
            [itemPipe]="parcelNumberPipe"
            (changed)="onParcelsChanged()"
          ></gmt-select>
        </gmt-input>
      </fieldset>

      <div *ngIf="similarGeometricPlanRequestExists" class="mt-20 text-center bordered error-message p-20">
        Existuje GP, který obsahuje jednu nebo více vybraných parcel.
      </div>

      <!-- PDF GP -->
      <fieldset>
        <legend class="required">Dokument PDF potvrzeného geometrického plánu katastrálním pracovištěm</legend>
        <fileupload class="blue" (change)="onGpFilesChange($event)" [message]="gpFilesMsg" [errorMsg]="gpFiles?.length && !gpFilesValid" inputId="gpHidden"></fileupload>
        <p class="text-center"><i>Vkládaný dokument PDF musí obsahovat elektronické razítko katastrálního pracoviště.</i></p>
      </fieldset>

      <!-- VFK GP -->
      <fieldset>
        <legend class="required">Soubor VFK předaný na katastrální pracoviště</legend>
        <fileupload class="blue" (change)="onGpVfkFilesChange($event)" [message]="gpVfkFilesMsg" [errorMsg]="gpVfkFiles?.length && !gpVfkFilesValid" inputId="gpVfkHidden"></fileupload>
      </fieldset>

      <!-- GP DOCUMENTATION -->
      <fieldset class="mt-60">
        <legend [ngClass]="{ required: geometricPlanRequest.type === typeEnum.EASEMENT_EXTENT }" style="top: -40px">Geodetická dokumentace GP (Tabulka výměr a délek pro případ GP na vyznačení VB, ZIP soubor obsahující ZPMZ, DGN kresbu a pod.)</legend>
        <fileupload class="yellow" (change)="onGpDocFilesChange($event)" [message]="gpDocFilesMsg" inputId="gpDocHidden"></fileupload>
      </fieldset>

      <!-- predbezny souhlas stavebniho uradu -->
      <fieldset *ngIf="type.id === typeEnum.PARCEL_SPLIT">
        <legend>Předběžné schválení dělení pozemků od SÚ</legend>
        <gmt-switch
          [options]="approveOptions"
          [selected]="parcelSplitPreApproveByOwner"
          (select)="parcelSplitPreApproveByOwner = $event"
        ></gmt-switch>
        <div class="column-100 mt-10">
          <label class="">Poznámka</label>
          <textarea [(ngModel)]="parcelSplitPreApproveByOwnerNote"></textarea>
        </div>
      </fieldset>

      <!-- predbezny souhlas vlastnika -->
      <fieldset *ngIf="type.id === typeEnum.PARCEL_SPLIT">
        <legend>Předběžný souhlas s dělením pozemků od vlastníka</legend>
        <gmt-switch
          [options]="approveOptions"
          [selected]="parcelSplitPreApproveByBuildingAuthority"
          (select)="parcelSplitPreApproveByBuildingAuthority = $event"
        ></gmt-switch>
        <div class="column-100 mt-10">
          <label class="">Poznámka</label>
          <textarea [(ngModel)]="parcelSplitPreApproveByBuildingAuthorityNote"></textarea>
        </div>
      </fieldset>

      <div class="mt-20 text-center">
        <gmt-button [gmtDisabled]="!isValid()" [clickAction]="onSubmit">Vložit GP a vytvořit požadavek na vložení nového stavu dle GP do aplikace</gmt-button>
      </div>
    </div>
  </div>
</div>
